import * as actionTypes from './actionTypes';
const initialState = {
  errorMessages: [],
  successMessages: [],
  planType: '',
  selectType: 'cumulative',
  rebateProgram: null,
  startDate: null,
  endDate: null,
  errors: null,
  rebateprogramlist: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_ERROR_MESSAGES_PRT:
      return { ...state, errorMessages: action.payload };
    case actionTypes.SET_SUCCESS_MESSAGES:
      return { ...state, successMessages: action.payload };
    case actionTypes.SET_PLAN_TYPE:
      return { ...state, planType: action.payload };
    case actionTypes.SET_SELECT_TYPE:
      return { ...state, selectType: action.payload };
    case actionTypes.SET_REBATE_PROGRAM:
      return { ...state, rebateProgram: action.payload };
    case actionTypes.SET_START_DATE:
      return { ...state, startDate: action.payload };
    case actionTypes.SET_END_DATE:
      return { ...state, endDate: action.payload };
    case actionTypes.SET_ERRORS:
      return { ...state, errors: action.payload };
    case actionTypes.SET_NEWORK_ERROR:
      return { ...state, isNetworkError: action.payload };
    case actionTypes.SET_REBATE_LIST:
      return { ...state, rebate_list: action.payload };
    case actionTypes.RESET_PERIODIC_REPORT_STORE:
      return { ...initialState };
    default:
      return { ...state };
  }
};

export default reducer;
